import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {useTranslate} from '@computerrock/formation-i18n';
import {useStyles, Modal, HighlightCircle, ContentBlock, ContentItem} from '@ace-de/ui-components';
import {ButtonPrimary, ButtonSecondary} from '@ace-de/ui-components/buttons';
import {Icon, closeIcon, warningOutlinedIcon} from '@ace-de/ui-components/icons';
import * as serviceCaseActionTypes from '../serviceCaseActionTypes';

const ConfirmVehicleSelectionModal = props => {
    const {cx} = useStyles();
    const {createTranslateShorthand} = useTranslate();
    const translateModal = createTranslateShorthand('confirm_vehicle_selection_modal');
    const {confirmVehicleSelect, declineVehicleSelect, hasBackdrop} = props;

    return (
        <Modal
            action={(
                <Icon icon={closeIcon} onClick={declineVehicleSelect} />
            )}
            hasBackdrop={hasBackdrop}
        >
            <ContentBlock className={cx([
                'global!ace-u-flex',
                'global!ace-u-flex--direction-column',
                'global!ace-u-flex--justify-center',
                'global!ace-u-flex--align-center',
            ])}
            >
                <ContentItem className={cx([
                    'ace-c-content-item--large-span-11',
                    'global!ace-u-flex',
                    'global!ace-u-flex--align-center',
                    'global!ace-u-flex--direction-column',
                ])}
                >
                    <HighlightCircle
                        className={cx([
                            'ace-c-highlight-circle--medium',
                            'global!ace-u-margin--bottom-32',
                            'ace-c-highlight-circle--primary',
                        ])}
                    >
                        <Icon
                            icon={warningOutlinedIcon}
                            className={cx([
                                'ace-c-icon--xxl',
                                'ace-c-icon--color-highlight-pressed',
                            ])}
                        />
                    </HighlightCircle>
                    <p
                        className={cx([
                            'global!ace-u-margin--bottom-32',
                            'global!ace-u-typography--variant-h3',
                        ])}
                    >
                        {translateModal('title.select_vehicle')}
                    </p>
                    <p
                        className={cx([
                            'global!ace-u-margin--bottom-32',
                            'global!ace-u-typography--align-center',
                        ])}
                    >
                        {translateModal('heading.select_vehicle')}
                    </p>
                </ContentItem>
                <ContentItem
                    className={cx([
                        'global!ace-u-flex--direction-column',
                        'global!ace-u--margin-0',
                    ])}
                >
                    <ButtonPrimary
                        className={cx(['global!ace-u-margin--bottom-24', 'global!ace-u-full-width'])}
                        onClick={confirmVehicleSelect}
                    >
                        {translateModal('button_label.yes')}
                    </ButtonPrimary>
                    <ButtonSecondary
                        className={cx('global!ace-u-full-width')}
                        onClick={declineVehicleSelect}
                    >
                        {translateModal('button_label.abort')}
                    </ButtonSecondary>
                </ContentItem>
            </ContentBlock>
        </Modal>
    );
};

ConfirmVehicleSelectionModal.propTypes = {
    declineVehicleSelect: PropTypes.func.isRequired,
    confirmVehicleSelect: PropTypes.func.isRequired,
    hasBackdrop: PropTypes.bool,
};

ConfirmVehicleSelectionModal.defaultProps = {
    hasBackdrop: true,
};

const mapDispatchToProps = dispatch => ({
    declineVehicleSelect: () => dispatch({type: serviceCaseActionTypes.DECLINE_SELECT_SERVICE_CASE_VEHICLE}),
    confirmVehicleSelect: () => dispatch({type: serviceCaseActionTypes.CONFIRM_SELECT_SERVICE_CASE_VEHICLE}),
});

export default connect(null, mapDispatchToProps)(ConfirmVehicleSelectionModal);
